import*as React from"react";import{WPPopover}from"@wp/src/components/common/WPPopover/WPPopover";import styled from"@emotion/styled";import{InfoTooltip}from"@wp/src/components/common/tooltip";const StyledPopover=styled(WPPopover)`
  .ant-popover-inner,
  .ant-popover-arrow:before {
    background-color: #000000d9;
  }

  .ant-popover-inner,
  .ant-popover-inner-content {
    * {
      color: ${props=>props.theme.colors.white};
    }
  }
`;export const GPDisclaimerPopover=props=>{return React.createElement(StyledPopover,props,props.children?props.children:React.createElement(InfoTooltip,null))};